
import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import AdminDashboard from './role-specific/AdminDashboard';
import FinanceDashboard from './role-specific/FinanceDashboard';
import WarehouseDashboard from './role-specific/WarehouseDashboard';
import SellerDashboard from './role-specific/SellerDashboard';
import SupportDashboard from './role-specific/SupportDashboard';
import BenchmarkDashboard from './role-specific/BenchmarkDashboard';
import BenchmarkManagerDashboard from './role-specific/BenchmarkManagerDashboard';
import CoordinatorDashboard from './role-specific/CoordinatorDashboard';
import QualityDashboard from './role-specific/QualityDashboard';
import Layout from '@/components/layout/Layout';

const RoleDashboardRouter: React.FC = () => {
  const { userRole } = useAuth();

  console.log('Current user role for dashboard routing:', userRole);

  switch (userRole) {
    case 'admin':
      return <AdminDashboard />;
    case 'finance':
      return <FinanceDashboard />;
    case 'procurement':
    case 'warehouse':
      return <WarehouseDashboard />;
    case 'seller':
      return <SellerDashboard />;
    case 'support':
      return <SupportDashboard />;
    case 'benchmark':
      return <BenchmarkDashboard />;
    case 'benchmark_manager':
      return <BenchmarkManagerDashboard />;
    case 'coordinator':
      return <CoordinatorDashboard />;
    case 'quality':
      return <QualityDashboard />;
    default:
      console.log('Using default dashboard for role:', userRole);
      // Instead of rendering Dashboard component (which causes infinite loop),
      // render a simple default dashboard
      return (
        <div className="space-y-6">
          <div className="mb-8">
            <h1 className="text-3xl font-bold">Dashboard</h1>
            <p className="text-muted-foreground mt-1">Welcome to your dashboard</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-lg shadow">
              <h2 className="text-lg font-semibold mb-2">Getting Started</h2>
              <p className="text-muted-foreground">Your role-specific dashboard will appear here once configured.</p>
            </div>
          </div>
        </div>
      );
  }
};

export default RoleDashboardRouter;
